import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';
import GoogleMap from 'google-map-react';

import { fitBounds } from 'google-map-react/utils';
import Ajax from './AJAX.jsx';
import InteractiveTable from './InteractiveTable.jsx';
import * as tools from "./tools.jsx";

import {DropDownMultiSelector} from "./DropDownSelector.jsx";

import ChangePositionView from "./ChangePositionView.jsx";
import {CompPlayer} from "./genericCompPlayer.js";

const DrawPositionCircle = function(props)
{
	const isMarked = props.markedId == props.compId;
	return(
		<div style={{left:"-15px", top:"-15px", position:"absolute"}}>
			<svg height="30" width="30">
		        <circle r="10" cx="15" cy="15" fillOpacity="0" strokeWidth={ isMarked? 5 : 2} stroke={isMarked ? "purple" : "red"}/>
		    </svg>
	    </div>
		)
}

const DrawTrackpoint = function(props)
{
	const isMarked = props.markedId == props.compId;
	return(
		<div style={{left:"-1px", top:"-1px", position:"absolute"}}>
			<svg height="3" width="3">
		        <circle r="1" cx="1" cy="1" fillOpacity="1" stroke="yellow"/>
		    </svg>
	    </div>
		)
}

const hideColumns = ["composition_id", "position"];

const mapOptions = {
  overviewMapControl: false,
  streetViewControl: false,
  rotateControl: true,
  mapTypeControl: true,
  mapTypeId:"satellite",
  draggable: true, /*zoomControl: false, */scrollwheel: false, disableDoubleClickZoom: false,
  // disable poi
  //styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
  //minZoom: DEFAULT_MIN_ZOOM, // dynamically recalculted if possible during init
  }

const mapStyle = {
	position:"relative",
	width:700,
	height:300,		
}

const startPos = { lng:12.695131, lat:55.908899 };


const tableContainerStyle= {
	maxHeight:"30vh",
	overflow:"scroll",
}
export class PlaylistCompsEditor extends React.Component {

    constructor(props)
    {
	    super(props);

	    this.state =
	    {
	    	markedId: -1,
	    	comps: props.value,
	    	data_comps: [],
			gpxData: [],
			loadGPXRef: null,
	    }
	    
	    const receiveComps = (response) =>
	    {
		    if(tools.checkResponseForErr(this, response))
		    {
		    	this.setState({data_comps: response.result});
		    }
	    }

	    this.props.appCallbacks.performAjaxRequest("compositions", "GET", null,
                        receiveComps, false);

		const showReposition = (comp) =>
	    {
	    	const registerNewPos = (newPos) => {
	    		//console.log("NewPos: ", newPos);
	    		if(newPos != null)
	    		{	
	    			comp.position = newPos; //Chage position of the comp (will not trigger re-render)

	    			const newComp = Object.assign({}, comp, {position: newPos});

	    			const newComps = this.state.comps.map((c)=>{
	    				return c.composition_id == comp.composition_id ? newComp : c});

	    			//update state with a copy of the array to force re-render
	    			this.setState({comps: newComps});
	    			props.onChange(newComps);
	    		}
	    		props.appCallbacks.popModal();
	    	}
	    	const modalProps = {
		        startPos:{lat: comp.position.lat, lng: comp.position.lng},
		        changePositionCallback:registerNewPos,
	      	};

	      	props.appCallbacks.pushModal({modalClass:ChangePositionView, modalProps:modalProps});
	    	console.log("Show RePos");
	    }

	    const removeComp = (comp) =>
	    {
	    	console.log("Remove comp");
	    }

	    const markPosition = (comp) =>
	    {
	    	this.setState({markedId: comp.composition_id});
	    }

	    this.extraBtns = [
	        {name:'reposition', click:showReposition},
	        {name:'mark', click: markPosition},
			{name:"play", click:this.clickedPlay.bind(this)}
	    ];

	    this.compPlayer = new CompPlayer((msg)=>{this.props.appCallbacks.showMsg("Comp Player:", msg)});

		this.setGPX = (gpxData) => {


			try{
				var parser, xmlDoc;
		
				parser = new DOMParser();
				xmlDoc = parser.parseFromString(gpxData,"text/xml");
				const longlats = Array.from(xmlDoc.getElementsByTagName("gpx")[0].getElementsByTagName("trk")[0].getElementsByTagName("trkseg")[0].getElementsByTagName("trkpt")).map(elem=>{return {lat: elem.getAttribute("lat"), lng: elem.getAttribute("lon")}});

				//this.setState({gpx:longlats});
				console.log("longlats: ", longlats);

				//gpxData = longlats;
				this.setState({gpxData: longlats});
				
				/*const track = gpx[0].getElementsByTagName("trk");
				console.log("Track: ", track)
				trackpoints = track[0].getElementsByTagName("trkpt");
				console.log("trackpoints elems: ", trackpoints);
				trackpoints.map(elem=>{return {lat: elem.getAttribute("lat"), lon: elem.getAttribute("lon")}});*/
			}
			catch(e){
				console.log("Caught error processing gpx: ", e);
			}
		
		}
   }

   componentDidUpdate(prevProps, prevState)
   {
	   console.log("Updating component. ", {prev:prevState, new:this.state});
	   if(this.state.loadGPXRef != prevState.loadGPXRef)
	   {
		   console.log("gpx elem changed");
		   this.state.loadGPXRef.addEventListener('change', (event) => {
			   const fileList = event.target.files;
			   if(fileList.length > 0)
			   {
				   fileList[0].text().then(textRes=>{this.setGPX(textRes)});
			   }
			   console.log(fileList);
			});
		}
   }
   

   clickedPlay(comp)
   {
	   const dataComp = this.state.data_comps.find((dC)=>dC.composition_id == comp.composition_id);
	   this.compPlayer.togglePlayComp(dataComp);
	}
	
	onChangeIncluded(includedCompIds)
	{
		//First filter away - then add
		
		const editedComps = this.state.comps.filter((c)=>{return includedCompIds.includes(c.composition_id)});
		
		for (var i = includedCompIds.length - 1; i >= 0; i--) {
			const compId = includedCompIds[i];
			if(editedComps.find((eC)=>{return eC.composition_id == compId}) == null)
			{
				const comp = this.state.data_comps.find((c)=>{return c.composition_id == compId});
				
				editedComps.push({composition_id:comp.composition_id, position:comp.position});
				
			}
		}
		
		this.setState({comps: editedComps});
		
   	this.props.onChange(editedComps);
   }

   render()
   {
	   	console.log("Render playlist edit")
   		const remapComp = (comp) =>
		{
			const dataComp = this.state.data_comps.find((dC) => {return dC.composition_id == comp.composition_id;});

			return Object.assign({}, comp, (dataComp == null ? {} : {name: dataComp.name}));
		}
		const remappedAvailableComps = this.state.data_comps.map((c)=>{return{id:c.composition_id, name:c.name}});
   		const remappedComps = this.state.comps.map(remapComp);
   		var centerAndZoom;
   		
   		if(remappedComps.length > 0)
   		{
	   		const extremes = tools.findSWNEExtremes(remappedComps.map((obj)=>obj.position));
	   		centerAndZoom = fitBounds(extremes, mapStyle);
   		}
   		else
   		{
   			centerAndZoom = {center:{lat:56, lng:11}, zoom:5};
   		}

   		//console.log("Center and Zoom and extremes: ", centerAndZoom);
   		/*const idsWithLogLat = remappedComps.map((rmC) => return {
   			longitude: rmC.position.lng,
   			latitude: rmC.position.lat,
   			composition_id: rmC.composition_id,
   		});
*/
   	//	console.log("Remapped Available and remapped comps: ", remappedAvailableComps, remappedComps);
      return (
      	this.state.data_comps.length == 0 ? null :
      	<div>
			<label for="viewGPX">View GPX file on map: </label>
			<input type="file" id="file-selector" id="viewGPX" ref={(ref)=>{this.state.loadGPXRef=ref}} accept=".gpx"></input>
      		{<GoogleMap options={mapOptions} bootstrapURLKeys={{key:"AIzaSyA3jDZgzpuoyAJ41dc9Nqs6D2lNjw3Tv5w"}}
                center={centerAndZoom.center} style={mapStyle}
                defaultZoom={15} zoom={centerAndZoom.zoom}>
                {remappedComps.map((rmC, i) => {return(
                	<DrawPositionCircle key={i} {...rmC.position} compId={rmC.composition_id} markedId={this.state.markedId}/>
                	)})}
				{
					this.state.gpxData.map((trkpt)=><DrawTrackpoint {...trkpt}/>)	
				}
					
              </GoogleMap>}
              <DropDownMultiSelector onChange={this.onChangeIncluded.bind(this)} objects={remappedAvailableComps} value={this.state.comps.map((c)=>{return c.composition_id;})}/>
			  <div style={tableContainerStyle}>
	      		<InteractiveTable extraBtns={this.extraBtns}
	      		rowObjects={remappedComps} hideColumns={hideColumns}/>
	      	</div>
      	</div>
      	)
   }
}



// WEBPACK FOOTER //
// ./js/playlistCompsEditor.jsx